import { SvgIcon } from '../../../../components/Icon';
import * as PlanDetailsUI from '../PlanDetailsUI';
import React, { MouseEventHandler } from 'react';

interface IProps {
  onClick: MouseEventHandler;
  title: string;
}

const PlanActionsAdmin = ({ onClick, title }: IProps) => {
  return (
    <PlanDetailsUI.EditMTUButton type="button" onClick={onClick}>
      {title}
      <SvgIcon name="pencil" customFill="currentColor" width={16} height={16} />
    </PlanDetailsUI.EditMTUButton>
  );
};

export default PlanActionsAdmin;
